import { render, staticRenderFns } from "./FinalizeOrder.vue?vue&type=template&id=c52a81d0&"
import script from "./FinalizeOrder.vue?vue&type=script&lang=js&"
export * from "./FinalizeOrder.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeOrder.vue?vue&type=style&index=0&id=c52a81d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports